/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiAIImageResponseFromJSON, ApiAISessionPayloadToJSON, ApiBillingFromJSON, ApiBillingToJSON, ApiCreateSessionResponseFromJSON, ApiGenerateChartResponseFromJSON, ApiListAISessionsPromptsResponseFromJSON, ApiListAISessionsResponseFromJSON, ApiListBillingsResponseFromJSON, ApiReadPromptResultResponseFromJSON, InlineObjectToJSON, InlineObject1ToJSON, InlineObject2ToJSON, } from '../models';
/**
 *
 */
export class AiServiceApi extends runtime.BaseAPI {
    /**
     */
    aiServiceCancelSessionPromptRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceCancelSessionPrompt.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling aiServiceCancelSessionPrompt.');
            }
            if (requestParameters.promptId === null || requestParameters.promptId === undefined) {
                throw new runtime.RequiredError('promptId', 'Required parameter requestParameters.promptId was null or undefined when calling aiServiceCancelSessionPrompt.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling aiServiceCancelSessionPrompt.');
            }
            const queryParameters = {};
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}/prompts/{sessionId}/prompts/{promptId}/cancel`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"promptId"}}`, encodeURIComponent(String(requestParameters.promptId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiAISessionPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    aiServiceCancelSessionPrompt(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceCancelSessionPromptRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceCreateBillingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling aiServiceCreateBilling.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/billing`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiBillingToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiBillingFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceCreateBilling(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceCreateBillingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceCreateSessionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceCreateSession.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling aiServiceCreateSession.');
            }
            const queryParameters = {};
            if (requestParameters.sessionId !== undefined) {
                queryParameters['sessionId'] = requestParameters.sessionId;
            }
            if (requestParameters.promptId !== undefined) {
                queryParameters['promptId'] = requestParameters.promptId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiAISessionPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiCreateSessionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceCreateSession(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceCreateSessionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceCreateSessionPromptRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceCreateSessionPrompt.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling aiServiceCreateSessionPrompt.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling aiServiceCreateSessionPrompt.');
            }
            const queryParameters = {};
            if (requestParameters.promptId !== undefined) {
                queryParameters['promptId'] = requestParameters.promptId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}/prompts/{sessionId}/prompts`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiAISessionPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListAISessionsPromptsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceCreateSessionPrompt(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceCreateSessionPromptRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceDeleteSessionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceDeleteSession.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling aiServiceDeleteSession.');
            }
            const queryParameters = {};
            if (requestParameters.payloadPrompt !== undefined) {
                queryParameters['payload.prompt'] = requestParameters.payloadPrompt;
            }
            if (requestParameters.payloadUseMcpAgent !== undefined) {
                queryParameters['payload.useMcpAgent'] = requestParameters.payloadUseMcpAgent;
            }
            if (requestParameters.promptId !== undefined) {
                queryParameters['promptId'] = requestParameters.promptId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}/sessions/{sessionId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    aiServiceDeleteSession(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceDeleteSessionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceEditImageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceEditImage.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling aiServiceEditImage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/image/{projectId}/edit`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObject2ToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiAIImageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceEditImage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceEditImageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceGenerateChartRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceGenerateChart.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling aiServiceGenerateChart.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/chart/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObjectToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiGenerateChartResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceGenerateChart(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceGenerateChartRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceGenerateImageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceGenerateImage.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling aiServiceGenerateImage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/ai/v1/image/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObject1ToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiAIImageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceGenerateImage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceGenerateImageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceListBillingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadCost !== undefined) {
                queryParameters['payload.cost'] = requestParameters.payloadCost;
            }
            if (requestParameters.payloadVersion !== undefined) {
                queryParameters['payload.version'] = requestParameters.payloadVersion;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.Name'] = requestParameters.payloadName;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/ai/v1/billing`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListBillingsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceListBilling(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceListBillingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceListPromptBillingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceListPromptBilling.');
            }
            const queryParameters = {};
            if (requestParameters.sessionId !== undefined) {
                queryParameters['sessionId'] = requestParameters.sessionId;
            }
            if (requestParameters.payloadPrompt !== undefined) {
                queryParameters['payload.prompt'] = requestParameters.payloadPrompt;
            }
            if (requestParameters.payloadUseMcpAgent !== undefined) {
                queryParameters['payload.useMcpAgent'] = requestParameters.payloadUseMcpAgent;
            }
            if (requestParameters.promptId !== undefined) {
                queryParameters['promptId'] = requestParameters.promptId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/ai/v1/billing/{projectId}/prompts`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListAISessionsPromptsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceListPromptBilling(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceListPromptBillingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceListSessionPromptsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceListSessionPrompts.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling aiServiceListSessionPrompts.');
            }
            const queryParameters = {};
            if (requestParameters.payloadPrompt !== undefined) {
                queryParameters['payload.prompt'] = requestParameters.payloadPrompt;
            }
            if (requestParameters.payloadUseMcpAgent !== undefined) {
                queryParameters['payload.useMcpAgent'] = requestParameters.payloadUseMcpAgent;
            }
            if (requestParameters.promptId !== undefined) {
                queryParameters['promptId'] = requestParameters.promptId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}/sessions/{sessionId}/prompts`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListAISessionsPromptsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceListSessionPrompts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceListSessionPromptsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceListSessionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceListSessions.');
            }
            const queryParameters = {};
            if (requestParameters.sessionId !== undefined) {
                queryParameters['sessionId'] = requestParameters.sessionId;
            }
            if (requestParameters.payloadPrompt !== undefined) {
                queryParameters['payload.prompt'] = requestParameters.payloadPrompt;
            }
            if (requestParameters.payloadUseMcpAgent !== undefined) {
                queryParameters['payload.useMcpAgent'] = requestParameters.payloadUseMcpAgent;
            }
            if (requestParameters.promptId !== undefined) {
                queryParameters['promptId'] = requestParameters.promptId;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListAISessionsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceListSessions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceListSessionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    aiServiceReadSessionPromptResultRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling aiServiceReadSessionPromptResult.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling aiServiceReadSessionPromptResult.');
            }
            if (requestParameters.promptId === null || requestParameters.promptId === undefined) {
                throw new runtime.RequiredError('promptId', 'Required parameter requestParameters.promptId was null or undefined when calling aiServiceReadSessionPromptResult.');
            }
            const queryParameters = {};
            if (requestParameters.payloadPrompt !== undefined) {
                queryParameters['payload.prompt'] = requestParameters.payloadPrompt;
            }
            if (requestParameters.payloadUseMcpAgent !== undefined) {
                queryParameters['payload.useMcpAgent'] = requestParameters.payloadUseMcpAgent;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from.toISOString();
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/ai/v1/sessions/{projectId}/prompts/{sessionId}/prompts/{promptId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"promptId"}}`, encodeURIComponent(String(requestParameters.promptId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadPromptResultResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    aiServiceReadSessionPromptResult(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aiServiceReadSessionPromptResultRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
    * @export
    * @enum {string}
    */
export var AiServiceListBillingPayloadTypeEnum;
(function (AiServiceListBillingPayloadTypeEnum) {
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_UNSPECIFIED"] = "AIBillingTypeUnspecified";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_CHART_BUILDER"] = "AIBillingTypeChartBuilder";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_CHART_ANALYSIS"] = "AIBillingTypeChartAnalysis";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_DEEP_DIVE"] = "AIBillingTypeDeepDive";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_LANDING_PAGE_BUILD"] = "AIBillingTypeLandingPageBuild";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_COMPONENT_BLOCK"] = "AIBillingTypeComponentBlock";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_CHART_BASIC_ANALYSIS"] = "AIBillingTypeChartBasicAnalysis";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_IMAGE_GENERATION"] = "AIBillingTypeImageGeneration";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_IMAGE_EDITING"] = "AIBillingTypeImageEditing";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_IMAGE_GENERATION_CONTEXT"] = "AIBillingTypeImageGenerationContext";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_IMAGE_EDITING_CONTEXT"] = "AIBillingTypeImageEditingContext";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_LANDING_PAGE_ADVANCED"] = "AIBillingTypeLandingPageAdvanced";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_LANDING_COMPONENT"] = "AIBillingTypeLandingComponent";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_LANDING_COMPONENT_ADVANCED"] = "AIBillingTypeLandingComponentAdvanced";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_LANDING_BLOCK"] = "AIBillingTypeLandingBlock";
    AiServiceListBillingPayloadTypeEnum["AI_BILLING_TYPE_LANDING_BLOCK_ADVANCED"] = "AIBillingTypeLandingBlockAdvanced";
})(AiServiceListBillingPayloadTypeEnum || (AiServiceListBillingPayloadTypeEnum = {}));
